import Vue from "vue";
import axios from "axios";
import snotify from "./plugins/snotify";
import { SnotifyStyle } from "vue-snotify";
import utility from "./plugins/utility";
import moment from "moment";
import * as d3 from "d3";
import "./filters";

window.Vue = Vue;
window.moment = moment;
window.d3 = d3;
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
}

let snotifyConfig = {
  toast: {
    bodyMaxLength: 250,
    titleMaxLength: 50,
    timeout: 5000,
  },
  type: {
    [SnotifyStyle.confirm]: {
      backdrop: 0.5,
    },
    [SnotifyStyle.prompt]: {
      backdrop: 0.5,
    },
  },
};
Vue.use(snotify, snotifyConfig);

Vue.use(utility);

window.Event = new (class {
  constructor() {
    this.vue = new Vue();
  }

  fire(event, data = null) {
    this.vue.$emit(event, data);
  }

  listen(event, callback) {
    this.vue.$on(event, callback);
  }
})();
